/**
 * @author: Yaochao
 * @date: 2021-07-01 19:40
 * @description：时间相关公共方法
 */

/**
 * 时间倒计时
 * @param count 要倒计时的秒数
 * @param step 倒计时每一步回调
 * @param finish 倒计时结束回调
 */
export const countDown = (count, step, finish) => {
    function doCountDown() {
        if (count > 0) {
            count--;
            if (step) {
                step(count + 1);
            }
            setTimeout(doCountDown, 1000)
        } else if (finish) {
            finish();
        }
    }

    doCountDown();
};